/**
 * Profile Types - Persona, Style, and Book Profile
 *
 * These types define HOW content is written:
 * - Persona: WHO writes (voice, vocabulary, influences)
 * - Style: HOW they write (structure, formality, devices)
 * - BookProfile: "Knowing" a book (themes, philosophy, tone)
 */
/**
 * Factory for creating a default CuratorPersona
 */
export function createDefaultCuratorPersona(uri, displayName = 'Guide') {
    const now = Date.now();
    const id = `curator_${now}_${Math.random().toString(36).slice(2, 8)}`;
    return {
        type: 'curator-persona',
        id,
        uri,
        name: displayName,
        tags: ['curator', 'global-assistant'],
        createdAt: now,
        updatedAt: now,
        canonic: {
            passageRefs: [],
            systemPrompt: `You are ${displayName}, a thoughtful assistant helping the user explore and curate their personal archives. You synthesize rather than lecture. You understand rather than viralize. You help the user become smarter about themselves.`,
            commitmentThreshold: 0.7,
            coreStances: [],
        },
        worldview: {
            passageRefs: [],
            embeddingAnchors: [],
            domains: [],
            flexibility: 0.8,
        },
        memory: {
            bestPractices: [],
            preferences: [],
            significantMoments: [],
            recurringThemes: [],
            lastConsolidatedAt: now,
        },
        appearance: {
            displayName,
            icon: 'guide',
            position: 'corner',
        },
        state: {
            isActive: true,
            lastActiveAt: now,
            lastTrainedAt: now,
            interactionCount: 0,
        },
    };
}
// ═══════════════════════════════════════════════════════════════════
// TYPE GUARDS
// ═══════════════════════════════════════════════════════════════════
/**
 * Type guard for Persona
 */
export function isPersona(entity) {
    return (typeof entity === 'object' &&
        entity !== null &&
        entity.type === 'persona');
}
/**
 * Type guard for Style
 */
export function isStyle(entity) {
    return (typeof entity === 'object' &&
        entity !== null &&
        entity.type === 'style');
}
/**
 * Type guard for CuratorPersona
 */
export function isCuratorPersona(entity) {
    return (typeof entity === 'object' &&
        entity !== null &&
        entity.type === 'curator-persona');
}
//# sourceMappingURL=profile.js.map